import { getBooking } from "../../../app/api/getBooking";
import { BaseAction } from "../../../core/actions/BaseAction";
import { isActionRunSuccessfully } from "../../../Lib/Utils/validationUtil";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse, IBookedOffer, IBookingResponse, ITrip } from "../../../Orchestrator/Types/Index";
import { calculateAlreadyPaidAddonsAction } from "../Addons/CalculateAlreadyPaidAddons";
import { getAllOfferWithoutExchangeAction } from "../CommonActions/GetAllOfferWithoutExchangeAction";
import { getAllTripWithoutExchangeAction } from "../CommonActions/GetAllTripWithoutExchangeAction";

interface IUpgradeBookingInitActionParams {
    bookingId: string;
}

class UpgradeBookingInitAction extends BaseAction<void, IUpgradeBookingInitActionParams> {
    override async run(): Promise<void> {
        const { bookingId } = this.params!;
        try {
            const response: IApiResponse<IBookingResponse> = await getBooking(bookingId);
            if (response.status === 'ok' && response.answer) {
                const bookingResponse: IBookingResponse = response.answer;
                /**
                * Manage Addons into booking for booking change trip date.
                * Checking that existing booking have addons or not.
                * If have addons then we need to prepare payment summary for already paid addons amount.
                * That already paid addons amount will be show into payment summary section.
                */                
                let allBookedOfferWithoutExchange: IBookedOffer[] = []
                getAllOfferWithoutExchangeAction.setParams(bookingResponse.booking.bookedOffers)
                await getAllOfferWithoutExchangeAction.execute();
                if (isActionRunSuccessfully(getAllOfferWithoutExchangeAction)) {
                    allBookedOfferWithoutExchange = getAllOfferWithoutExchangeAction?.result || []
                }
                let allBookedTripsWithoutExchange: ITrip[] = []
                getAllTripWithoutExchangeAction.setParams({ bookedOffers: allBookedOfferWithoutExchange, trips: bookingResponse.booking.trips })
                await getAllTripWithoutExchangeAction.execute();
                if (isActionRunSuccessfully(getAllTripWithoutExchangeAction)) {
                    allBookedTripsWithoutExchange = getAllTripWithoutExchangeAction?.result || []
                }
                calculateAlreadyPaidAddonsAction.setParams({
                    allBookedOfferWithoutExchange: allBookedOfferWithoutExchange,
                    allBookedTripWithoutExchange: allBookedTripsWithoutExchange
                })
                await calculateAlreadyPaidAddonsAction.execute();                

                updateRecoilState('bookingResponseAtom', bookingResponse);
            }
        } catch (error) {
        }
    }
}

export const upgradeBookingInitAction = new UpgradeBookingInitAction();
